<app-home-main-banner></app-home-main-banner>

<app-home-featured-services></app-home-featured-services>

<app-home-services></app-home-services>

<section class="what-we-do-area p-5">
    <app-what-we-do></app-what-we-do>
</section>


<section class="partner-area bg-ffffff ptb-70 py-5">
    <app-partner></app-partner>
</section>


<app-project-start></app-project-start>